import {ColorButton} from "../features/userPoints/userPointsSlice";

export const ImageUpload = ({
                               title,
                               uploadId,
                               currentImageSrc,
                               previewFile,
                               inputRef,
                               onUpload,
                               onSave,
                               saveDisabled,
                               alt,
    classes,
                           }) => (
    <>
        <div className={classes.title}>{title}</div>

        <div style={{ display: "flex" }}>
            <div style={{ marginRight: 24 }}>
                <label htmlFor={uploadId}>
                    <ColorButton component="span" variant="contained">
                        Update Image
                    </ColorButton>
                </label>
            </div>

            <div>
                <ColorButton disabled={saveDisabled} onClick={onSave}>
                    Save Changes
                </ColorButton>
            </div>
        </div>

        {currentImageSrc && (
            <div>
                <div className={classes.subTitle}>Current Image</div>
                <div className={classes.bannerImagePreview}>
                    <img
                        style={{ height: 50 }}
                        src={ currentImageSrc }
                        alt={alt}
                    />
                </div>
            </div>
        )}

        {previewFile && (
            <div>
                <div className={classes.subTitle}>Preview</div>
                <div className={classes.bannerImagePreview}>
                    <img style={{ height: 50 }} src={previewFile} alt={alt} />
                </div>
            </div>
        )}

        <input
            ref={inputRef}
            style={{ display: "none" }}
            accept="image/*"
            className={classes.input}
            id={uploadId}
            onChange={onUpload}
            type="file"
        />
    </>
);